import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { HiOutlinePlus } from "react-icons/hi";
import { Menu } from "@headlessui/react";
import {
  useDeleteCouponCredentialForTenantMutation,
  useGetCouponCredentialWithLimitOffsetForTenantMutation,
  useUpdateCouponCredentialStatusForTenantMutation,
} from "../../../features/tenant/couponCredential/couponCredentialApi";
import { toast } from "react-hot-toast";
import { hasPermission } from "../../../utils/hasPermission";
import { getVendorName } from "../../../utils/getVendorName";

const providerArray = [
  {
    id: 1,
    name: "prepaidocean",
    form: {
      name: ["client_id", "client_secret"],
      view_name: ["Client Id", "Client Secret"],
    },
  },
  {
    id: 2,
    name: "qwikcilver",
    form: {
      name: ["username", "password", "url"],
      view_name: ["Username", "Password", "Url"],
    },
  },
];

const CouponCredential = () => {
  const navigate = useNavigate();
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;
  const addCouponCredentialPermission = hasPermission("addCouponSetup") || true;
  const editCouponCredentialPermission = hasPermission("editCouponSetup") || true;
  const deleteCouponCredentialPermission = hasPermission("deleteCouponSetup") || true;
  const updateCouponCredentialStatusPermission = hasPermission("updateCouponSetup") || true;
  const viewCouponCredentialPermission = hasPermission("viewCouponSetup") || true;

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  const [
    getCouponCredentialWithLimitOffsetForTenant,
    {
      data: getCouponCredentialWithLimitOffsetForTenantData,
      isLoading: getCouponCredentialWithLimitOffsetForTenantIsLoading,
      isError: getCouponCredentialWithLimitOffsetForTenantIsError,
      error: getCouponCredentialWithLimitOffsetForTenantError,
    },
  ] = useGetCouponCredentialWithLimitOffsetForTenantMutation();

  const [
    deleteCouponCredentialForTenant,
    {
      data: deleteCouponCredentialForTenantData,
      isLoading: deleteCouponCredentialForTenantIsLoading,
      isError: deleteCouponCredentialForTenantIsError,
      error: deleteCouponCredentialForTenantError,
    },
  ] = useDeleteCouponCredentialForTenantMutation();

  const [
    updateCouponCredentialStatusForTenant,
    {
      data: updateCouponCredentialStatusForTenantData,
      isLoading: updateCouponCredentialStatusForTenantIsLoading,
      isError: updateCouponCredentialStatusForTenantIsError,
      error: updateCouponCredentialStatusForTenantError,
    },
  ] = useUpdateCouponCredentialStatusForTenantMutation();

  const fetchCouponCredential = (limit, offset) => {
    getCouponCredentialWithLimitOffsetForTenant({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      limit: limit,
      offset: offset,
    });
  };

  useEffect(() => {
    if (!viewCouponCredentialPermission) {
      navigate(`/genefied/${getVendorName()}/`);
    }
    fetchCouponCredential(limit, offset);
  }, [limit, offset]);

  useEffect(() => {
    if (getCouponCredentialWithLimitOffsetForTenantData) {
      toast.dismiss();
      toast.success(getCouponCredentialWithLimitOffsetForTenantData.message, {
        id: "getCouponCredentialWithLimitOffsetForTenantData",
      });
    }
    if (getCouponCredentialWithLimitOffsetForTenantError) {
      toast.dismiss();
      toast.error("Oops some error occurred", {
        id: "getCouponCredentialWithLimitOffsetForTenantError",
      });
    }
  }, [
    getCouponCredentialWithLimitOffsetForTenantData,
    getCouponCredentialWithLimitOffsetForTenantError,
  ]);

  if (getCouponCredentialWithLimitOffsetForTenantIsLoading) {
    toast.loading("Loading ..", {
      id: "getCouponCredentialWithLimitOffsetForTenantIsLoading",
    });
  }

  const handleEditCouponCredential = (row, form) => {
    if (editCouponCredentialPermission) {
      navigate("add", {
        state: {
          data: row,
          form: form,
          edit: true,
        },
      });
    } else {
      toast.error("You don't have permission to edit credentials", {
        id: "edit_permission_error",
      });
    }
  };

  const handleDeleteCouponCredential = (row) => {
    if (deleteCouponCredentialPermission) {
      deleteCouponCredentialForTenant({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: row.id,
      });
    } else {
      toast.error("You don't have permission to delete credentials", {
        id: "delete_permission_error",
      });
    }
  };

  const handleStatusChange = (row, status) => {
    if (updateCouponCredentialStatusPermission) {
      updateCouponCredentialStatusForTenant({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: Number(row.id),
      });
    } else {
      toast.error("You don't have permission to change status", {
        id: "status_permission_error",
      });
    }
  };

  useEffect(() => {
    if (deleteCouponCredentialForTenantData) {
      toast.dismiss();
      toast.success("Deleted Successfully", {
        id: "deleteCouponCredentialForTenantData",
      });
    }
    if (deleteCouponCredentialForTenantError) {
      toast.dismiss();
      toast.error("Oops, something went wrong", {
        id: "deleteCouponCredentialForTenantError",
      });
    }
    fetchCouponCredential(limit, offset);
  }, [deleteCouponCredentialForTenantData, deleteCouponCredentialForTenantError]);

  useEffect(() => {
    if (updateCouponCredentialStatusForTenantData) {
      toast.dismiss();
      toast.success("Status Updated Successfully", {
        id: "updateCouponCredentialStatusForTenantData",
      });
    }
    if (updateCouponCredentialStatusForTenantError) {
      toast.dismiss();
      toast.error("Oops, something went wrong", {
        id: "updateCouponCredentialStatusForTenantError",
      });
    }
    fetchCouponCredential(limit, offset);
  }, [
    updateCouponCredentialStatusForTenantData,
    updateCouponCredentialStatusForTenantError,
  ]);

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "90px",
      textAlign: "left",
    },
    {
      name: "Credentials",
      width: "300px",
      cell: (row) => {
        return providerArray.map((p) => {
          if (p.name === row.type) {
            return p.form?.name.map((x, index) => {
              if (index < Object.keys(row.api_credential).length) {
                return (
                  <div className="" key={index}>
                    <div className="w-32 mr-2 mb-2 m-2">
                      <label htmlFor={`field-${index}`} className="mb-1"> {p?.form.view_name[index]} </label>
                      <input
                        name={x}
                        className="form-control"
                        value={Object.values(row.api_credential)[index]}
                        type="text"
                        readOnly
                      />
                    </div>
                  </div>
                );
              } else {
                return <React.Fragment key={index}></React.Fragment>;
              }
            });
          } else {
            return <React.Fragment key={p.id}></React.Fragment>;
          }
        });
      },
      sortable: true,
    },
    {
      name: "Type",
      cell: (row) => row.type,
      sortable: true,
    },
    {
      name: "",
      cell: (row) =>
        row.status === "1" ? (
          <button
            onClick={() => {
              handleStatusChange(row, "2");
            }}
            className="flex justify-center items-center rounded bg-green-900 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
          >
            Active
          </button>
        ) : (
          <button
            onClick={() => {
              handleStatusChange(row, "1");
            }}
            className="flex justify-center items-center rounded bg-gray-900 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-gray-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-gray-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-gray-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
          >
            InActive
          </button>
        ),
      sortable: true,
    },
    {
      name: "",
      cell: (row) => (
        <div className="">
          <button
            onClick={() => {
              providerArray.map((p) => {
                if (p.name === row.type) {
                  handleEditCouponCredential(row, p);
                }
              });
            }}
            className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
          >
            <AiOutlineEdit className="mr-1" />
            edit
          </button>
        </div>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <button
          onClick={() => handleDeleteCouponCredential(row)}
          className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#dc4c64] transition duration-150 ease-in-out hover:bg-danger-600 hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:bg-danger-600 focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:outline-none focus:ring-0 active:bg-danger-700 active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(220,76,100,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)]"
        >
          <AiOutlineDelete className="mr-1" />
          Delete
        </button>
      ),
      minWidth: "130px",
    },
  ];

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Coupon Credentials
            <LinksComponent />
          </div>
          <div className="p-3">
            <div className="p-3 bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.id}
                columns={columns}
                data={
                  getCouponCredentialWithLimitOffsetForTenantData &&
                  getCouponCredentialWithLimitOffsetForTenantData.body.data
                }
                totalRows={
                  getCouponCredentialWithLimitOffsetForTenantData &&
                  getCouponCredentialWithLimitOffsetForTenantData.body.total
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
              />
              {addCouponCredentialPermission && (
                <div
                  className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                  id="box_btn"
                >
                  <div className="text-right">
                    <Menu className="relative inline-block text-left">
                      <div>
                        <Menu.Button
                          onClick={() => navigate(`add`)}
                          className="inline-flex justify-center w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none"
                          style={{ backgroundColor: `${primaryColor["700"]}` }}
                        >
                          <HiOutlinePlus className="w-full h-full p-3" />
                        </Menu.Button>
                      </div>
                    </Menu>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouponCredential;
